import CreateTemplateTab from "../../components/CreateTamplateTab";
import ChooseTemplate from "../../components/Forms/ChooseTemplate";
import EditTemplateform from "../../components/Forms/EditTemplateform";
import BasicCard from "../BasicCard"
import Dummylayout from "../Dummylayout";
function EditTemplatemain(){

    return(
       <>
       <Dummylayout/>
     <BasicCard>
        <EditTemplateform/>
     </BasicCard>
     
        
       </>

    )
};
export default EditTemplatemain;
